export default __webpack_public_path__ + "static/1421-9d5e7931c12e1196c99ceb6182feeab7.gif";